import { CookiesStorageService } from '@/services/cookiesStorageService';
import { COOKIES_KEYS } from '@/constants/cookiesKeys';
import { GOOGLE_ID } from '@/constants/googleEvents';
import { getUrlParams } from './getUrlParams';
import { windowIsReady } from './windowIsReady';

const readRawCookie = (name: string): string => {
	if (!windowIsReady) return '';
	const cookies = document.cookie ? document.cookie.split('; ') : [];
	for (const c of cookies) {
		const [k, ...rest] = c.split('=');
		if (k === name) return decodeURIComponent(rest.join('='));
	}
	return '';
};

/**
 * Detect which paid traffic source the user came from and decide
 * which marketing pixels are allowed to fire events.
 *
 * Rules:
 * - fbclid (URL/cookie) or _fbc cookie → Facebook traffic
 * - gclid (URL/cookie) → Google traffic
 * - Only-FB traffic blocks Google events
 * - Only-Google traffic blocks Facebook events
 * - Both or neither → both allowed (no isolation)
 */
export const getTrafficSource = () => {
	const { fbclid: urlFbclid, gclid: urlGclid } = getUrlParams();

	const fbclid =
		urlFbclid || CookiesStorageService.get(COOKIES_KEYS.FBCLID, '');
	const fbc = readRawCookie('_fbc');
	const gclid = urlGclid || CookiesStorageService.get(GOOGLE_ID.GCLID, '');

	const isFb = Boolean(fbclid || fbc);
	const isGoogle = Boolean(gclid);

	return {
		isFb,
		isGoogle,
		allowFacebook: !isGoogle || isFb,
		allowGoogle: !isFb || isGoogle,
	};
};
